export default __webpack_public_path__ + "static/media/cp_geo_ye.f5eed2e9.svg";